






























































import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'

@Component
export default class PlayClassModal extends ViewBase {
  @Prop({ type: Object, default: () => ({}) }) data!: object
  @Prop({ type: Boolean, default: true }) visible!: boolean
  doc: any

  labelCol = { span: 24 }

  wrapperCol = { span: 24 }

  lang = {}

  isEdit = false

  school = ''

  svisible = false

  notAllow: boolean = false

  clientGroupId: any = ''

  classId: any = ''
  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  created() {
    this.doc = window.document
    this.school = JSON.parse(localStorage.school).school_key
    this.lang = this.i18n.vBinding
  }

  @Watch('visible')
  watchVisible(visible: any) {
    this.svisible = visible
    const data: any = this.data
    if (data.classList.length > 0 && data.classList[0].class_id) {
      this.classId = data.classList[0].class_id
    }
    if (data.clientGroupList.length > 0 && data.clientGroupList[0].client_group_id) {
      this.clientGroupId = data.clientGroupList[0].client_group_id
    }
  }
  onCancel() {
    this.$emit('onCancel')
  }
  async onOk() {
    try {
      localStorage.classId = this.classId
      localStorage.clientGroupId = this.clientGroupId
      this.$emit('onOk')
    } catch (ex) {
      this.handleError(ex)
    }
  }
}
